export default "__VITE_PUBLIC_ASSET__aa5f9086__"